import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home/Home';
import HomeSistemaImoveis from './pages/Home/HomeSistemaImoveis';
import HomeFrota from './pages/Home/HomeFrota';
import HomeColheita from './pages/Home/HomeColheita';
import CadastroVeiculos from './pages/SistemaGestaoFrotas/CadastroVeiculos/CadastroVeiculos';
import ViewVeiculos from './pages/SistemaGestaoFrotas/ViewVeiculos/ViewVeiculos';
import ViewVeiculo from './pages/SistemaGestaoFrotas/ViewVeiculo/ViewVeiculo';
import CadastroImoveis from './pages/SistemaGestaoImoveis/ImovelDetails/CadastroImoveis/CadastroImoveis';
import ViewImoveis from './pages/SistemaGestaoImoveis/ImovelDetails/ViewImoveis/ViewImoveis';
import DespesasGerais from './pages/SistemaGestaoImoveis/ExpensePages/DespesasGerais/DespesasGerais';
import ImovelDetails from './pages/SistemaGestaoImoveis/ImovelDetails/ImovelDetails/ImovelDetails';
import GerenciarUsuarios from './pages/GerenciarUsuarios/GerenciarUsuarios';
import Login from './pages/Login/Login';
import Perfil from './pages/Perfil/Perfil';
import ManutencaoFrota from './pages/SistemaGestaoFrotas/ManutencaoFrota/ManutencaoFrota';
import DespesasGeraisVeiculos from './pages/SistemaGestaoFrotas/Despesas/DespesasGerais'; 
import CadastroEquipeColheita from './pages/SistemaGestaoColheita/CadastroEquipe';
import ListaEquipes from './pages/SistemaGestaoColheita/ListaEquipes';
import EquipeDetalhes from './pages/SistemaGestaoColheita/EquipeDetalhes';
import EditarEquipe from './pages/SistemaGestaoColheita/EditarEquipe';
import ProducaoDiaria from './pages/SistemaGestaoColheita/ProducaoDiariaMock';
import Vencimentos from './pages/SistemaGestaoFrotas/Vencimentos/Vencimentos';
import './App.css';

// Rotas permitidas para o operador (com Regex para rotas dinâmicas)
const OPERATOR_ALLOWED_PATHS = [
    '/',
    '/perfil',
    '/colheita/registro-producao-operador',
    // Rota dinâmica real que eles podem precisar para o registro, ex: /equipes/1/registrar-producao
    /^\/equipes\/\d+\/registrar-producao$/
];


const App = () => {
  const [authenticated, setAuthenticated] = useState(false);

  const checkAuth = () => {
    const isAuthenticated = localStorage.getItem('authenticated') === 'true';
    setAuthenticated(isAuthenticated);
  };

  useEffect(() => {
    checkAuth();

    const handleStorageChange = (e) => {
      if (e.key === 'authenticated') {
        checkAuth();
      }
    };
    window.addEventListener('storage', handleStorageChange);

    const handleForcedLogout = () => {
      checkAuth(); 
    };
    window.addEventListener('storage-logout', handleForcedLogout);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('storage-logout', handleForcedLogout);
    };
  }, []); 

  const handleLoginSuccess = () => {
    setAuthenticated(true);
  };

  const ProtectedRoute = ({ element }) => {
    const userType = (localStorage.getItem('tipo_usuario') || '').trim().toLowerCase();
    const path = window.location.pathname;

    if (!authenticated) {
      return <Navigate to="/login" />;
    }

    // --- LÓGICA DE RESTRIÇÃO PARA OPERADOR (ADICIONADA) ---
    if (userType === 'operador') {
        // Verifica se a rota atual é permitida (estática ou dinâmica)
        const isPathAllowed = OPERATOR_ALLOWED_PATHS.some(allowedPath => {
            if (typeof allowedPath === 'string') {
                return path === allowedPath;
            } else if (allowedPath instanceof RegExp) {
                return allowedPath.test(path);
            }
            return false;
        });

        if (!isPathAllowed) {
            // Redireciona para o ponto de entrada de produção se a rota for proibida
            return <Navigate to="/" />; 
        }
    }
    // --- FIM DA LÓGICA DE RESTRIÇÃO ---

    return element;
  };

  const AdminRoute = ({ element }) => {
    const userType = localStorage.getItem('tipo_usuario');
    if (authenticated && userType === 'admin_geral') {
      return element;
    }
    return <Navigate to="/" />;
  };

  return (
    <Router>
      <div className="d-flex flex-column min-vh-100">
        <Header isAuthenticated={authenticated} setAuthenticated={setAuthenticated} />
        
        <div className="flex-grow-1">
          <Routes>
            <Route 
              path="/login" 
              element={
                authenticated ? (
                  <Navigate to="/" />
                ) : (
                  <Login onLoginSuccess={handleLoginSuccess} />
                )
              } 
            />
            
            <Route path="/" element={<ProtectedRoute element={<Home />} />} />
            
            <Route path="/sistema-imoveis" element={<ProtectedRoute element={<HomeSistemaImoveis />} />} />
            <Route path="/sistema-frota" element={<ProtectedRoute element={<HomeFrota />} />} />
            <Route path="/sistema-colheita" element={<ProtectedRoute element={<HomeColheita />} />} />

            <Route path="/frota/cadastro-veiculo" element={<ProtectedRoute element={<CadastroVeiculos />} />} />
            <Route path="/frota/veiculos" element={<ProtectedRoute element={<ViewVeiculos />} />} />
            <Route path="/frota/veiculos/:id" element={<ProtectedRoute element={<ViewVeiculo />} />} />
            <Route path="/frota/manutencao" element={<ProtectedRoute element={<ManutencaoFrota />} />} />
            <Route path="/frota/despesasGerais" element={<ProtectedRoute element={<DespesasGeraisVeiculos />} />} />

            <Route path="/cadastro-imoveis" element={<ProtectedRoute element={<CadastroImoveis />} />} />
            <Route path="/view-imoveis" element={<ProtectedRoute element={<ViewImoveis />} />} />
            <Route path="/despesas-gerais" element={<ProtectedRoute element={<DespesasGerais />} />} />
            <Route path="/imovel/:id" element={<ProtectedRoute element={<ImovelDetails />} />} />
            
            <Route path="/cadastro-equipe-colheita" element={<ProtectedRoute element={<CadastroEquipeColheita />} />} />
            <Route path="/lista-equipes" element={<ProtectedRoute element={<ListaEquipes />} />} />
            <Route path="/lista-equipes/:id" element={<ProtectedRoute element={<EquipeDetalhes />} />} />
            <Route path="/editar-equipe/:id" element={<ProtectedRoute element={<EditarEquipe />} />} />
            <Route
  path="/frota/vencimentos"
  element={<ProtectedRoute element={<Vencimentos />} />}
/>

            {/* ROTAS DE PRODUÇÃO */}
            <Route 
                path="/equipes/:equipeId/registrar-producao" 
                element={<ProtectedRoute element={<ProducaoDiaria />} />} 
            />
            {/* NOVO PONTO DE ENTRADA DO OPERADOR (Rotas como esta devem ser resolvidas no backend/contexto para redirecionar para o :equipeId correto) */}
            <Route 
                path="/colheita/registro-producao-operador" 
                element={<ProtectedRoute element={<ProducaoDiaria />} />} 
            />

            
            <Route path="/perfil" element={<ProtectedRoute element={<Perfil />} />} />
            
            <Route path="/gerenciar-usuarios" element={<AdminRoute element={<GerenciarUsuarios />} />} />

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
};

export default App;